<form [formGroup]="form" class="contents">
  <div class="flex gap-1 self-center text-h2 font-semibold">
    {{
      (undefined | collaborationDynamicTitle: allParticipants() : dialogData.currentUserIds) ||
        ('collab_new_collab_modal_new_collab' | translate)
    }}
  </div>
  <div class="flex flex-col gap-6 rounded-[40px] bg-background-white/80 p-6 backdrop-blur">
    <div class="flex flex-col gap-6">
      @if (!dialogData.disableEdit) {
        <div class="flex justify-between gap-10">
          <div class="typo-h4-light flex h-[54px] w-12 items-center text-text-primary">{{ 'collab_new_collab_modal_to' | translate }}</div>
          <div class="flex-1 flex-col">
            <lib-search-participants
              [currentUser]="currentUser"
              [allParticipants]="allParticipants()"
              [minimumSearchLength]="1"
              [options]="employees()"
              [placeholder]="
                (isShowcase()
                  ? 'collab_new_collab_modal_collaboration_participant_showcase_placeholder'
                  : 'collab_new_collab_modal_collaboration_provider_placeholder'
                ) | translate
              "
              [inviteLabel]="'collab_new_collab_modal_collaboration_invite_participant_label' | translate"
              [noResultLabel]="'collab_new_collab_modal_collaboration_no_result_label' | translate"
              [loading]="employeesLoading()"
              [disabled]="!siteId()"
              [isShowcaseMode]="isShowcase()"
              [closeOnSelect]="true"
              [isError]="noParticipantError()"
              [errorHint]="
                noParticipantError()
                  ? ((dialogData.isEditing
                      ? 'collab_new_collab_modal_not_enough_participant_error_hint'
                      : 'collab_new_collab_modal_no_participant_error_hint'
                    ) | translate)
                  : ''
              "
              (searchTerm)="onSearchProviders($event)"
              (itemSelected)="onAddProviderParticipant($event)"
              (endReached)="onProvidersEndReached()"
            />
            <ng-container [ngTemplateOutlet]="participants"></ng-container>
          </div>
        </div>

        <div class="flex items-center justify-between gap-10">
          <div class="typo-h4-light w-12 text-text-primary">{{ 'collab_new_collab_modal_subject' | translate }}</div>
          <lib-input
            class="flex-1"
            [formControl]="form.controls.subject"
            [placeholder]="'collab_add_subject_input' | translate"
            [state]="form.controls.subject.value.length > subjectMaxLength ? 'error' : 'normal'"
            [hint]="form.controls.subject.value.length > subjectMaxLength ? ('collab_add_subject_error_hint_long' | translate) : ''"
            [maxLength]="subjectMaxLength + 1"
          >
            <svg-icon
              rightIcon
              size="md"
              key="px-24-cancel"
              class="hover:cursor-pointer"
              [class.invisible]="!form.controls.subject.value"
              (click)="onClearSubjectClick()"
            ></svg-icon>
          </lib-input>
        </div>
      } @else {
        <div class="typo-h5-book">{{ 'collab_new_collab_modal_collaboration_participant_label' | translate }}</div>
        <ng-container [ngTemplateOutlet]="participants"></ng-container>
      }
    </div>

    <ng-template #participants>
      @if (employeeParticipants().length || emailParticipants()) {
        <div class="mt-2 flex max-h-34 flex-col gap-1 overflow-auto">
          @for (provider of employeeParticipants(); track provider.id) {
            <lib-selected-participant [participant]="provider" (removeParticipant)="onRemoveEmployeeParticipant($event)" />
          }
          @for (email of emailParticipants(); track email) {
            <lib-selected-participant [participant]="email" (removeParticipant)="onRemoveEmailParticipant($event)" />
          }
        </div>
      }
    </ng-template>

    <div class="flex w-full items-center justify-between gap-2">
      <div class="rounded-lg bg-background-tag px-2 pb-0.5">
        <span class="typo-h5-semibold text-primary-blue">
          {{ (linkedPatient() ? 'collab_type_clinical_collab' : 'collab_type_team_collab') | translate }}
        </span>
      </div>
      @if (linkedPatient(); as linkedPatient) {
        <a
          class="flex items-center gap-1"
          target="_blank"
          [routerLink]="['/', routes.site, siteId(), routes.patients, linkedPatient.id, routes.charting]"
          [libUiTooltip]="patientTooltip"
          [tooltipPosition]="'top'"
        >
          <span class="typo-h5-book">{{ linkedPatient.firstName }} {{ linkedPatient.lastName }}</span>
          <svg-icon key="px-24-chart" size="sm" class="text-primary-blue-pressed"></svg-icon>
        </a>
        <ng-template #patientTooltip>
          <div class="typo-h5-book p-2 text-text-secondary">
            {{
              (dialogData.isEditing ? 'collab_edit_collab_modal_patient_tooltip' : 'collab_new_collab_modal_patient_tooltip') | translate
            }}
          </div>
        </ng-template>
      }
    </div>
  </div>
  <div class="flex gap-10 self-end">
    @if (dialogData.disableEdit) {
      <button type="button" class="btn-primary" (click)="closeDialog()">{{ 'collab_modify_button_done_title' | translate }}</button>
    } @else {
      <button type="button" class="btn-text" (click)="closeDialog()">{{ 'collab_new_collab_modal_cancel' | translate }}</button>
      <button [disabled]="form.controls.subject.value.length > subjectMaxLength" type="button" class="btn-primary" (click)="saveCollab()">
        @if (dialogData.isEditing) {
          {{ 'collab_new_collab_modal_save' | translate }}
        } @else {
          {{ 'collab_new_collab_modal_create_collab' | translate }}
        }
      </button>
    }
  </div>
</form>
